import type { GameVariant } from '@/types/reward-machine';
import { getEntryData as getEntryDataFromLib } from '@/lib/customer-data';

export const getEntryData = async (serverTime: string, gameVariant?: GameVariant) => {
    return getEntryDataFromLib(serverTime, gameVariant);
};
